export default "__VITE_ASSET__V6atNO0N__"